import {
  ApolloLink,
  ApolloProvider,
  ApolloClient as Client,
  HttpLink,
  InMemoryCache,
  from
} from '@apollo/client';
import {
  onAuthErrorRedirectLink,
  setAccessTokenLink,
  useAuth
} from '@payflip/web/auth';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  uri: string;
  apolloClientName?: string;
  links?: ApolloLink[];
};

export function ApolloClient({
  children,
  uri,
  apolloClientName = 'react-client',
  links = []
}: Props): JSX.Element {
  const { getAccessToken } = useAuth();

  const gqlApiLink = new HttpLink({ uri });

  const link = from([
    setAccessTokenLink(getAccessToken),
    onAuthErrorRedirectLink(),
    ...links,
    gqlApiLink
  ]);

  const client = new Client({
    name: apolloClientName,
    link,
    cache: new InMemoryCache()
  });

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
